export default "__VITE_ASSET__DdN$Rt$2__"